<template>
  <div class="container-fluid adp-admin-container-fluid">
    <div class="row">
      <div class="col">
        <div class="dropdown mr-1" style="display: inline;">
          <button class="btn adp-btn dropdown-toggle" type="button" id="rolesMenuButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
            {{ $t('admin.roles') }}
          </button>
          <div class="dropdown-menu" aria-labelledby="rolesMenuButton">
            <div class="dropdown-item" @click="selectedRole = 'employees'">
              {{ $t('role.employees') }}
              <span v-if="selectedRole === 'employees'">&nbsp;&nbsp;&nbsp;<img src="/images/check-mark.svg" alt=""></span>
            </div>
            <div class="dropdown-item" @click="selectedRole = 'hrs'">
              {{ $t('role.hr') }}
              <span v-if="selectedRole === 'hrs'">&nbsp;&nbsp;&nbsp;<img src="/images/check-mark.svg" alt=""></span></div>
            <div class="dropdown-item" @click="selectedRole = 'managers'">
              {{ $t('role.managers') }}
              <span v-if="selectedRole === 'managers'">&nbsp;&nbsp;&nbsp;<img src="/images/check-mark.svg" alt=""></span>
            </div>
            <div class="dropdown-item" @click="selectedRole = 'functional_managers'">
              {{ $t('role.fmanagers') }}
              <span v-if="selectedRole === 'functional_managers'">&nbsp;&nbsp;&nbsp;<img src="/images/check-mark.svg" alt=""></span>
            </div>
          </div>
        </div>

        <button type="button" class="btn adp-btn mr-1" @click="createNew()">
          {{ addNewUser }}
        </button>

        <div class="dropdown" style="display: inline;" v-if="selectedRole === 'employees'">
          <button type="button" class="btn adp-btn js-show-modal-report" id="reportsMenuButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
            {{ $t('admin.report_button') }}
          </button>
          <div class="dropdown-menu" aria-labelledby="reportsMenuButton">
            <a class="dropdown-item">{{ $t('admin.report_idp') }}</a>
            <a class="dropdown-item">{{ $t('admin.report_mandatory_learning') }}</a>
          </div>
        </div>
      </div>
    </div>

    <div v-if="loading">{{ $t('voc.loading') }}</div>
    <div class="adp-grid-table" v-if="!loading">
      <div class="adp-grid-row adp-grid-row__admin">
        <div class="d-flex flex-column adp-grid-cell__head" style="padding: 0 16px">
            <span class="adp-th adp-th__sort" :class="{'adp-th__active': sortingPernumber !== null}" @click="sortChange('sortingPernumber')">
              {{ $t('admin.id') }} <img :src="getSortingIcon(sortingPernumber)" alt="sort">
            </span>
          <input @input="filterEmployee" type="text" class="adp-input adp-input__catalog adp-input-search" v-model="filterPernumber">
        </div>
        <div class="d-flex flex-column adp-grid-cell__head">
            <span class="adp-th adp-th__sort" :class="{'adp-th__active': sortingName !== null}" @click="sortChange('sortingName')">
              <template v-if="selectedRole === 'employees'">
                {{ $t('role.employee') }} <img :src="getSortingIcon(sortingName)" alt="sort">
              </template>
              <template v-if="selectedRole === 'hrs'">
                {{ $t('role.hr') }} <img :src="getSortingIcon(sortingName)" alt="sort">
              </template>
              <template v-if="selectedRole === 'managers'">
                {{ $t('role.manager') }} <img :src="getSortingIcon(sortingName)" alt="sort">
              </template>
              <template v-if="selectedRole === 'functional_managers'">
                {{ $t('admin.fmanager') }} <img :src="getSortingIcon(sortingName)" alt="sort">
              </template>
            </span>
          <input @input="filterEmployee" type="text" class="adp-input adp-input__catalog adp-input-search" v-model="filterName">
        </div>
        <div class="d-flex flex-column adp-grid-cell__head">
            <span class="adp-th adp-th__sort" :class="{'adp-th__active': sortingCompany !== null}" @click="sortChange('sortingCompany')">
              {{ $t('admin.be') }} <img :src="getSortingIcon(sortingCompany)" alt="sort">
            </span>
          <my-dropdown :options="companies" :init-selected="filterCompany" :has-select-all="true" :localize="false"
                       v-on:my-change="onDropdownUpdate($event, 'filterCompany')">
          </my-dropdown>
        </div>

        <template v-if="selectedRole === 'employees'">
          <div class="d-flex flex-column adp-grid-cell__head">
            <span class="adp-th adp-th__sort" :class="{'adp-th__active': sortingPosition !== null}" @click="sortChange('sortingPosition')">
              {{ $t('admin.position') }} <img :src="getSortingIcon(sortingPosition)" alt="sort">
            </span>
            <my-dropdown :options="positions" :init-selected="filterPosition" :has-select-all="true" :localize="false"
                         v-on:my-change="onDropdownUpdate($event, 'filterPosition')">
            </my-dropdown>
          </div>
          <div class="d-flex flex-column adp-grid-cell__head">
            <span class="adp-th adp-th__sort" :class="{'adp-th__active': sortingWhiteList !== null}" @click="sortChange('sortingWhiteList')">
              {{ $t('admin.in_white_list') }} <img :src="getSortingIcon(sortingWhiteList)" alt="sort">
            </span>
            <my-dropdown :options="whiteLists" :init-selected="filterWhiteList" :has-select-all="true" :localize="false"
                         v-on:my-change="onDropdownUpdate($event, 'filterWhiteList')">
            </my-dropdown>
          </div>
        </template>

        <template v-if="selectedRole === 'hrs'">
          <div>
            <div class="d-flex flex-column adp-grid-cell__head adp-th mb-3">{{ $t('admin.connections') }}</div>
            <div class="d-flex flex-column adp-grid-cell__head adp-th mt-0">{{ $t('admin.be') }}</div>
          </div>
          <div class="d-flex flex-column adp-grid-cell__head adp-th">{{ $t('admin.office') }}</div>
        </template>

        <template v-if="selectedRole === 'managers' || selectedRole === 'functional_managers'">
          <div>
            <div class="d-flex flex-column adp-grid-cell__head adp-th mb-3">{{ $t('admin.employee') }}</div>
            <div class="d-flex flex-column adp-grid-cell__head adp-th mt-0">{{ $t('admin.fio') }}</div>
          </div>
          <div class="d-flex flex-column adp-grid-cell__head adp-th mt-3">{{ $t('admin.id') }}</div>
        </template>
      </div>
      <div class="adp-grid-row adp-grid-row__admin" v-for="(item, i) in items" :key="i" v-if="employees"
           @mouseenter="enterToListItem(i)" @mouseleave="leaveFromListItem()"
           :style="currentItemIndex === i ? 'backgroundColor: #F5F5F5' : ''">
        <div class="adp-grid-cell adp-grid-cell__code align-self-baseline" style="padding: 0 16px">
          {{ item.pernumber }}
        </div>
        <div class="adp-grid-cell adp-grid-cell__title align-self-baseline">
          {{ item.fullname }}
        </div>
        <div class="adp-grid-cell adp-grid-cell__title align-self-baseline">
          {{ item.company_name }}
        </div>

        <template v-if="selectedRole === 'employees'">
          <div class="adp-grid-cell adp-grid-cell__title">
            {{ item.position_name }}
          </div>
          <div class="adp-grid-cell adp-grid-cell__title">
            {{ item.added_by === 1 ? 'Нет' : 'Да' }}
          </div>
        </template>

        <template v-if="selectedRole === 'hrs'">
          <div class="d-flex flex-column">
            <div class="adp-grid-cell adp-grid-cell__title" v-for="item in item.companies">
              <div>{{ item.company.name }}</div>
            </div>
          </div>
          <div class="d-flex flex-column">
            <div class="adp-grid-cell adp-grid-cell__title" v-for="item in item.companies">
              <div>{{ item.department.name }}</div>
            </div>
          </div>
        </template>

        <template v-if="selectedRole === 'managers' || selectedRole === 'functional_managers'">
          <div class="d-flex flex-column">
            <div class="adp-grid-cell adp-grid-cell__title" v-for="item in item.employees">
              <div>{{ item.name }}</div>
            </div>
          </div>
          <div class="d-flex flex-column">
            <div class="adp-grid-cell adp-grid-cell__title" v-for="item in item.employees">
              <div>{{ item.pernumber }}</div>
            </div>
          </div>
        </template>

        <div class="d-flex justify-content-between pr-5 pl-4">
          <template v-if="selectedRole === 'employees' && currentItemIndex === i">
            <img src="/images/show.svg" style="width: 17px; cursor: pointer" @click="openEmployeeInNewTab(item)">
            <img src="/images/edit.svg" style="width: 17px; cursor: pointer" @click="editEmployee(item)">

            <img src="/images/delete.svg" style="width: 17px; cursor: pointer" @click="deleteEmployee(item)" v-if="item.added_by !== 1">
            <img src="/images/delete_disabled.svg" style="width: 17px; cursor: pointer;" v-else
                 @mouseenter="showDeleteEmployeeWarning" @mouseleave="showError = false">

            <div class="actions-button-error" :style="errorStyles" v-if="showError">
              {{ $t('admin.not_delete') }}
            </div>
          </template>
          <template v-if="selectedRole === 'hrs' && currentItemIndex === i">
            <div class="d-flex flex-column">
              <div v-for="hrdata in item.companies" class="adp-grid-cell" style="height: 47px">
                <img src="/images/delete.svg" style="width: 17px; cursor: pointer;" @click="deleteHrsLink(hrdata, item.fullname)">
              </div>
            </div>
          </template>
          <template v-if="(selectedRole === 'managers' || selectedRole === 'functional_managers') && currentItemIndex === i">
            <div class="d-flex flex-column">
              <div v-for="employee in item.employees" class="adp-grid-cell" style="height: 47px">
                <img src="/images/delete.svg" style="width: 17px; cursor: pointer;" v-if="employee.added_by !== 1"
                     @click="deleteManagersLink(employee, item)">
                <img src="/images/delete_disabled.svg" style="width: 17px; cursor: pointer;" v-else
                     @mouseenter="showDeleteManagerWarning" @mouseleave="showError = false">
              </div>
              <div class="actions-button-error" :style="errorStyles" v-if="showError">
                {{ $t('admin.not_delete_manager') }}
              </div>
            </div>
          </template>
        </div>
      </div>
    </div>

    <!-- Pagination -->
    <div class="adp-pagination mt-4" v-if="!loading">
      <div class="adp-pagination-bnt" v-for="(page, index) in pages" v-if="page.url || page.label === '...'" @click="changePage(page.label)"
           :class="{'adp-pagination-bnt__active': page.active}">
        <span v-if="page.label === 'pagination.previous' && page.url"><</span>
        <span v-else-if="page.label === 'pagination.next' && page.url">></span>
        <span v-else>{{ page.label }}</span>
      </div>
      <div style="width: 190px; margin-left: 30px">
        <v-select style="background-color: white" label="text"
                  :options="itemsPerPage"
                  :clearable="false"
                  v-model="itemsPerPageSelected"
                  @option:selecting="selectItemsPerPage($event)"
        >
        </v-select>
      </div>
    </div>

    <!-- Modals -->
    <employee-view-modal :employee="currentEmployee" @employee-updated="getEmployees()"/>
    <employee-create-modal @employee-created="getEmployees()" />
    <manager-create-modal :manager-type="selectedRole" @manager-created="getEmployees()" />
    <hr-create-modal @hr-created="getEmployees()" />
    <delete-employee-question-modal :employee="currentEmployee" @employee-deleted="getEmployees()" />
    <delete-hrs-link-question-modal :hrs-data="selectedHrsData" @hrs-link-deleted="getEmployees()" />
    <delete-managers-link-question-modal :manager-data="selectedManagerData" :manager-type="selectedRole" @managers-link-deleted="getEmployees()" />
  </div>
</template>

<script>
import MyDropdown from "../MyDropdown";
import api from "../../api";
import EmployeeViewModal from "./EmployeeViewModal";
import EmployeeCreateModal from "./EmployeeCreateModal";
import DeleteEmployeeQuestionModal from "./DeleteEmployeeQuestionModal";
import HrCreateModal from "./HrCreateModal";
import DeleteHrsLinkQuestionModal from "./DeleteHrsLinkQuestionModal";
import DeleteManagersLinkQuestionModal from "./DeleteManagersLinkQuestionModal";
import ManagerCreateModal from "./ManagerCreateModal";

export default {
  name: "AdminPage",
  components: {
    'manager-create-modal': ManagerCreateModal,
    'delete-managers-link-question-modal': DeleteManagersLinkQuestionModal,
    'delete-hrs-link-question-modal': DeleteHrsLinkQuestionModal,
    'hr-create-modal': HrCreateModal,
    'delete-employee-question-modal': DeleteEmployeeQuestionModal,
    'employee-create-modal': EmployeeCreateModal,
    'employee-view-modal': EmployeeViewModal,
    'my-dropdown': MyDropdown,
  },
  data: function () {
    return {
      loading: false,
      showError: false,

      currentItemIndex: null,
      currentEmployee: {},
      selectedRole: 'employees',

      selectedHrsData: {},
      selectedManagerData: {},

      activePage: 1,
      itemsPerPageCount: 20,
      itemsPerPage: [
        {number: 20, text: '20 на странице'},
        {number: 50, text: '50 на странице'},
        {number: 100, text: '100 на странице'},
      ],
      pages: [],

      items: [],
      employees: [],

      sortingPernumber: null,
      sortingName: null,
      sortingCompany: null,
      sortingPosition: null,
      sortingWhiteList: null,

      filterPernumber: '',
      filterName: '',
      filterCompany: [],
      filterPosition: [],
      filterWhiteList: [],

      companies: [],
      positions: [],
      whiteLists: [],

      error: {
        top: 0,
        left: 0,
      }
    }
  },
  computed: {
    itemsPerPageSelected: {
      get() {
        return this.itemsPerPage.find(item => item.number === this.itemsPerPageCount).text
      },
      set({number}) {
        this.itemsPerPageCount = number;
      }
    },
    addNewUser() {
      if (this.selectedRole === 'employees') return this.$t('admin.new_emp')
      if (this.selectedRole === 'hrs') return this.$t('admin.new_hr')
      if (this.selectedRole === 'managers') return this.$t('admin.new_manager')
      if (this.selectedRole === 'functional_managers') return this.$t('admin.new_functional_manager')
    },
    errorStyles() {
      return {
        top: `${this.error.top}px`,
        left: `${this.error.left}px`,
        right: 'unset',
      };
    },
  },
  watch: {
    async selectedRole(role) {
      this.loading = true;
      this.activePage = 1;
      const data = {
        page: this.activePage,
        count: this.itemsPerPageCount,
        role: role,
      };
      const resp = await api.getEmployeesList(data);
      this.employees = resp.data.data;
      this.pages = resp.data.links;
      await this.filterEmployee();
      this.loading = false;
    }
  },
  methods: {
    async getEmployees() {
      this.loading = true;
      const data = {
        page: this.activePage,
        count: this.itemsPerPageCount,
        role: this.selectedRole,
      };
      const resp = await api.getEmployeesList(data);
      this.employees = resp.data.data;
      this.pages = resp.data.links;
      await this.filterEmployee();
      this.loading = false;
    },
    sortChange(prop) {
      if (this[prop] === null) {
        this[prop] = 'asc';
      } else if (this[prop] === 'asc') {
        this[prop] = 'desc';
      } else if (this[prop] === 'desc') {
        this[prop] = null;
      }

      this.filterEmployee();
    },
    onDropdownUpdate(e, property) {
      this[property] = e;
      this.filterEmployee();
    },
    getSortingIcon(val) {
      if (val === null) {
        return '/images/sort.svg';
      } else if (val === 'asc') {
        return '/images/sort_active_asc.svg';
      } else if (val === 'desc') {
        return '/images/sort_active_desc.svg';
      }
    },
    async filterEmployee() {
      function dynamicSort(property) {
        let sortOrder = 1;
        if (property[0] === "-") {
          sortOrder = -1;
          property = property.substr(1);
        }
        return function (a, b) {
          let result = (a[property] < b[property]) ? -1 : (a[property] > b[property]) ? 1 : 0;
          return result * sortOrder;
        }
      }

      let items = this.employees;
      items = await this.searchItems();

      if (this.sortingPernumber) {
        let co = this.sortingPernumber === 'desc' ? '-' : '';
        items = items.sort(dynamicSort(`${co}pernumber`));
      } else if (this.sortingName) {
        let co = this.sortingName === 'desc' ? '-' : '';
        items = items.sort(dynamicSort(`${co}fullname`));
      } else if (this.sortingCompany) {
        let co = this.sortingCompany === 'desc' ? '-' : '';
        items = items.sort(dynamicSort(`${co}company_name`));
      }else if (this.sortingPosition) {
        let co = this.sortingPosition === 'desc' ? '-' : '';
        items = items.sort(dynamicSort(`${co}position_name`));
      }  else if (this.sortingWhiteList) {
        let co = this.sortingWhiteList === 'desc' ? '-' : '';
        items = items.sort(dynamicSort(`${co}added_by`));
      }

      this.items = JSON.parse(JSON.stringify(items));
    },
    async searchItems() {
      let items = this.allItems;
      const data = {
        page: this.activePage,
        count: this.itemsPerPageCount,
        role: this.selectedRole,
        search_pernumber: this.filterPernumber,
        search_name: this.filterName,
        search_company: this.filterCompany,
        search_position: this.filterPosition,
        search_white_list: this.filterWhiteList,
      };

      let resp = await api.getEmployeesList(data);
      items = resp.data.data;
      this.pages = resp.data.links;

      return items;
    },
    async selectItemsPerPage(event) {
      this.loading = true;
      try {
        event.number > 20 ? this.activePage = 1 : this.activePage
        const data = {
          page: this.activePage,
          count: event.number,
          role: this.selectedRole,
        };
        let resp = await api.getEmployeesList(data);
        this.employees = resp.data.data;
        this.pages = resp.data.links;

        await this.filterEmployee();
      } catch (e) {
        console.error(e);
      }
      this.loading = false;
    },
    changePage(val) {
      if(val === '...') {
        return;
      }

      if(val === 'pagination.previous') {
        val = Number(this.activePage) - 1;
      }

      if(val === 'pagination.next') {
        val = Number(this.activePage) + 1;
      }

      val = Number(val);

      this.activePage = val;
      if (val === 1) {
        val = null;
      }
      this.getEmployees();
    },
    enterToListItem(index) {
      this.currentItemIndex = index;
    },
    leaveFromListItem() {
      this.currentItemIndex = null;
    },
    openEmployeeInNewTab(employee) {
      let routeData = this.$router.resolve({ name: `${this.$role}-employee`, params: { pernumber: employee.pernumber }});
      window.open(routeData.href, '_blank');
    },
    editEmployee(employee) {
      this.currentEmployee = employee;
      this.$nextTick(() => this.$bvModal.show('employee-view-modal'));
    },
    deleteEmployee(employee) {
      this.currentEmployee = employee;
      if (this.selectedRole === 'employees') this.$nextTick(() => this.$bvModal.show('delete-employee-question-modal'));
    },
    showDeleteEmployeeWarning() {
      this.showError = true;
      this.$nextTick(() => {
        this.error.left = Number(event.pageX) - 550;
        this.error.top = Number(event.pageY) + 40;
      });
    },
    deleteHrsLink(hrData, hrName) {
      this.selectedHrsData = {
        fio: hrName,
        pernumber: hrData.pernumber,
        company: hrData.company,
        department: hrData.department,
      };
      this.$nextTick(() => this.$bvModal.show('delete-hrs-link-question-modal'));
    },
    deleteManagersLink(managerEmployee, manager) {
      this.selectedManagerData = {
        subordinate: managerEmployee.pernumber,
        subordinateName: managerEmployee.fullname,
        manager: manager.pernumber,
        managerFio: manager.fullname
      };
      this.$nextTick(() => this.$bvModal.show('delete-managers-link-question-modal'));
    },
    showDeleteManagerWarning() {
      this.showError = true;
      this.$nextTick(() => {
        this.error.left = Number(event.pageX) - 420;
        this.error.top = Number(event.pageY) + 30;
      });
    },
    createNew() {
      if (this.selectedRole === 'employees') this.$bvModal.show('employee-create-modal');
      if (this.selectedRole === 'hrs') this.$bvModal.show('hr-create-modal');
      if (this.selectedRole === 'managers' || this.selectedRole === 'functional_managers') this.$bvModal.show('manager-create-modal');
    },
  },
  async mounted() {
    await this.getEmployees();

    // const uniquePositions = [...new Set(this.items.map(item => item.position_name))];
    // this.positions = uniquePositions.map(item => ({id: String(item), code: String(item)}));
    this.positions = window.IDP.positions.map(item => ({id: String(item), code: String(item)}));

    // const uniqueCompanies = [...new Set(this.items.map(item => item.company_name))];
    // this.companies = uniqueCompanies.map(item => ({id: String(item), code: String(item)}));
    this.companies = Object.keys(window.IDP.companies).map(item => ({id: String(item), code: String(item)}));

    this.whiteLists = [{id: 1, code: 'Нет'}, {id: 2, code: 'Да'}];
  }
}
</script>
